module.exports = __webpack_public_path__ + "img/espectro.c6d1962a.png";